import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IUser } from 'app/shared/models/user.model';
import { SecurityService } from 'app/shared/services/security.service';
import { Subscription } from 'rxjs';
import { AppConfig } from 'app/app.config';
import { NgxSpinnerService } from 'ngx-spinner';
import { SnotifyService } from 'ng-snotify';
import { IDtoUser } from 'app/shared/models/security/dto-user.model';
import { IdentityService } from 'app/views/appviews/security/identity.service';
@Component({
  selector: 'login',
  templateUrl: 'login.template.html'
})
export class LoginComponent implements OnInit {
  private frmLogin: FormGroup;
  private user: IUser;
  private subscriptionLogin: Subscription;
  private authenticated = false;
  /**Validadores */
  private errorMessages: any;
  /**Notificaciones */
  private configToast: any;
  constructor(private formBuilder: FormBuilder
    , private serviceSecurity: SecurityService
    , config: AppConfig
    , public snotifyService: SnotifyService
    , private spinner: NgxSpinnerService
    , private identityService: IdentityService
    , private configGeneral: AppConfig) {
    this.user = serviceSecurity.MapNewUsuario();
    this.user.system = config.getConfig().name;
    this.frmLogin = formBuilder.group({
      username: [this.user.username, Validators.required],
      password: [this.user.password, Validators.required]
    });
  }

  ngOnInit() {
    this.subscriptionLogin = this.serviceSecurity.authenticationChallenge$.subscribe((res) => {
      this.authenticated = res;
      if (this.authenticated) {
        this.serviceSecurity.GetRolesUser('/dashboard/init');
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.snotifyService.error('Datos incorrectos'
          , 'Iniciar sesión', this.configToast);
      }
    });
  }

  private onSubmit(value: IUser) {

    if (this.frmLogin.valid) {
      this.spinner.show();
      this.login(value);
    } else {
      // validate all form fields
    }
  }

  private login(usuario: IUser) {
    usuario.code = this.user.code;
    usuario.system = this.user.system;
    this.serviceSecurity.GetAuthorizationUser(usuario);
  }

  private restorePassword(): void {
    const usernameValue = this.frmLogin.controls['username'].value;
    if (usernameValue === 'solicitudempleo@redpromex.com') {
      return;
    }

    this.spinner.show();
    let user = {} as IDtoUser;
    user.username = usernameValue;
    this.identityService.restorePassword(user)
        .subscribe(
            (x) => {
                this.configGeneral.notificationSuccessError(x)
                this.spinner.hide();
            },
            (errMessage) => this.errorMessages = errMessage.messages);
  }
}
